module.exports = __webpack_public_path__ + "static/media/educational_portal.7a804cbf.png";